<template>
	<section>
		<ui-create-task-modal
			name="global--create-task"
			:show-close-option="false"
			custom-close-event="custom-close-select-reserve"
		/>
		<ui-select-reserve-modal name="global--request-reserve" />
		<ui-create-deal-modal name="global--create-deal-modal" />
	</section>
</template>
<script>
	import { uiCreateTaskModal, uiSelectReserveModal, uiCreateDealModal } from '@/components/ui-facilita/modals'

	export default {
		components: {
			uiCreateTaskModal,
			uiSelectReserveModal,
			uiCreateDealModal
		},

		mounted() {
			const parameters = this.$route.query

			if (parameters.product) this.$root.$emit('modal-open-global--request-reserve', null, true, true, parameters)
			else this.$root.$emit('modal-open-global--request-reserve', null, true, true, null)
		},
	}
</script>
